import { PATIENT } from "./utils/constants";

export interface ConnectionHistoryChartInfo {
  serial: string;
  records: ConnectionHistoryChartRecord[];
}

export interface ConnectionHistoryChartRecord {
  ip: string;
  timeStarted: string;
  timeLastSeen: string;
}

export interface Device {
  name?: string;
  type: string;
  serial: string;
  model: string;
  patientID?: string;
  lastKnownIp?: string;
  lastActivity: string;
  createdAt: string;
  updatedAt: string;
}

export enum ScanResponseType {
  PATIENT = "PATIENT",
  DEVICE = "DEVICE"
}

export interface ScanResponse {
  type: ScanResponseType;
  device: ScannedDevice;
  patient: PatientDetails;
}

export interface ScannedDevice extends Device {
  isConnected: boolean;
}

export interface PatientDetails {
  id: string;
  phi: any;
  associatedDevices: Device[];
}

export interface Settings {
  autoSubmitChars: number;
  autoSubmitEnabled: boolean;
  autoSubmitIdleTimeout: number;
  disassociationTimeout: number;
  mobileSessionTimeout: number;
  patientBarcodePrefix: string;
  patientBarcodeRegex: string;
  patientBarcodeSuffix: string;
  scannerBarcodePrefix: string;
  scannerBarcodeRegex: string;
  scannerBarcodeSuffix: string;
  scannerSensitivity: number;
  ventilatorBarcodePrefix: string;
  ventilatorBarcodeRegex: string;
  ventilatorBarcodeSuffix: string;
  webSessionTimeout: number;
  workflowTimeout: number;
}
